module.exports = __webpack_public_path__ + "assets/img/newQuestiongreat@2x.6fb5e4a3.png";